/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/olerite/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from 'services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';
import moment from 'moment';

function* findById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: `olerites/${id}` });
    if (response.data && response.data.arquivos && response.data.arquivos.length > 0) {
      const arquivos = yield FileService.downloadArquivos(response.data.arquivos);
      if (arquivos && arquivos.length > 0) {
        response.data.file = { ...arquivos[0], alt: response.data.arquivos[0].title };
      }
    }
    yield put({
      type: TypeActions.OLERITE_FIND_ONE_SUCCESS,
      data: response.data,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: error.response?.data?.mensagem || 'Erro ao recuperar as informações!',
    });
  }
}

function* create({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    var arquivos = data.usuarios.map(u => u['file']);
    var itens = [];
    for (let usuario of data.usuarios) {
      itens.push({
        usuarioId: usuario.usuarioId,
        arquivos: FileService.getArquivosToUpload([usuario.file]),
        mesReferencia: moment(data.mesReferencia, "YYYY-MM"),
      });
    } 

    const response = yield BaseService.post({ url: 'olerites', data: { itens } });
    if (response.data && response.data.arquivos && response.data.arquivos.length > 0) {
      yield FileService.uploadArquivos(arquivos, response.data.arquivos);
    }

    yield put({ type: TypeActions.OLERITE_CREATE_SUCCESS, data: {} });
    yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: error.response?.data?.mensagem || 'Erro ao salvar as informações!',
    });
  }
}

function* update({ id, data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    var arquivos = [data['file']];
    var payload = {
      ...data,
      mesReferencia: moment(data.mesReferencia, "YYYY-MM"),
      arquivos: FileService.getArquivosToUpload(arquivos),
    }
    delete payload['file'];

    const response = yield BaseService.put({ url: `olerites/${id}`, data: payload });
    if (response.data && response.data.arquivos && response.data.arquivos.length > 0) {
      yield FileService.uploadArquivos(arquivos, response.data.arquivos);
    }

    yield put({ type: TypeActions.OLERITE_UPDATE_SUCCESS, data: {} });
    yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: error.response?.data?.mensagem || 'Erro ao salvar as informações!',
    });
  }
}

function* deleteOlerite({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.delete({ url: `olerites/${id}`});
    
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações removidas com sucesso!'
    });
    yield callback();
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: error.response?.data?.mensagem || 'Erro ao deletar!',
    });
  }
}

export default function* watchOlerite() {
  yield takeLatest(TypeActions.OLERITE_FIND_ONE, findById);
  yield takeLatest(TypeActions.OLERITE_CREATE, create);
  yield takeLatest(TypeActions.OLERITE_UPDATE, update);
  yield takeLatest(TypeActions.OLERITE_DELETE, deleteOlerite);
}
